@if (show) {
<div class="msg-container" (click)="hide()">
    <img src="./../../../../assets/icons/success-icon.svg" *ngIf="status === 'success'">
    <img src="./../../../../assets/icons/error-icon.svg" *ngIf="status === 'fail'">
    <div class="msg">
        {{msg}}
    </div>
</div>
}